/* Shim for the forked StudioCore code (design editor, AI Poster Maker): StudioCore's WalletContext shape over the
   Brightivity wallet (brightivity.dev/wallet — same rows, same /wallet/debit contract as desktop). */
import { useCallback, useEffect, useState } from 'react';
import { useWallet as useBvWallet } from '../app/wallet.jsx';
import { api } from '../api/client.js';
import { getPricing } from '../api/wallet.js';

let pricingCache = null;
let pricingLoad = null;
const loadPricing = () => {
  if (pricingCache) return Promise.resolve(pricingCache);
  if (!pricingLoad) {
    pricingLoad = getPricing().then((r) => {
      pricingLoad = null;
      if (r.ok && r.data && r.data.data) pricingCache = r.data.data.pricingMap || {};
      return pricingCache || {};
    });
  }
  return pricingLoad;
};
let pendingGeneration = false;

export function useWallet() {
  const w = useBvWallet();
  const [pricing, setPricing] = useState(pricingCache || {});
  useEffect(() => { let live = true; loadPricing().then((p) => { if (live) setPricing(p); }); return () => { live = false; }; }, []);
  const { balance, setBalance, refresh } = w;
  const getCost = useCallback((key) => pricing[key] || 0, [pricing]);
  const canAfford = useCallback((key) => {
    const cost = pricing[key];
    if (cost === undefined) return true;
    return (balance || 0) >= cost;
  }, [balance, pricing]);
  const debit = useCallback(async (featureKey, idempotencyKey) => {
    const r = await api('/wallet/debit', { method: 'POST', body: { featureKey, idempotencyKey } });
    const d = r.data || {};
    if (r.ok && d.success) {
      setBalance(d.data.newBalance);
      return { success: true, newBalance: d.data.newBalance, transactionId: d.data.transactionId };
    }
    return { success: false, status: r.status, error: d.error || r.error, data: d.data };
  }, [setBalance]);
  return {
    ...w,
    balance,
    pricing,
    balanceChanged: false,
    refreshBalance: refresh,
    getCost,
    canAfford,
    debit,
    markPendingGeneration: () => { pendingGeneration = true; },
    clearPendingGeneration: () => { pendingGeneration = false; },
    hasPendingGeneration: () => pendingGeneration,
  };
}
export default null;
